import React, { memo } from 'react'
import { withTranslation, useTranslation } from 'react-i18next'
import { useTheme, withStyles } from '@material-ui/core/styles'
import { Stepper, Step, Box, StepLabel, StepConnector } from '@material-ui/core'
import { useSelector } from 'react-redux'
import useStyles from './stepperVerticalStyle'
import moment from 'moment'

const RenderVerticalStepper = ({ history = null }) => {
  const { t } = useTranslation()
  const size = useSelector((state) => state.preferences)
  let useStylesParams = {
    size: size,
  }
  const classes = useStyles(useStylesParams)
  let verticalValue = 0;
  
  verticalValue = (history?.tabs?.length === 1 ? history?.tabs?.length : history?.tabs?.length + 1);

  if(history?.processData?.finished){
    verticalValue = verticalValue + 1;
  }

  const theme = useTheme()

  const VerticalConnector = withStyles({
    completed: {
      '& $line': {
        borderColor: theme.palette.primary.main,
      },
    },
    active: {
      '& $line': {
        borderColor: theme.palette.primary.main,
      },
    },
    line: {
      borderColor: '#286796',
      borderLeftWidth: '3px',
      marginLeft: '-1px',
      minHeight: '40px',
    },
  })(StepConnector)

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <Stepper
        activeStep={verticalValue}
        orientation="vertical"
        connector={
          <VerticalConnector style={{ padding: 0 }}></VerticalConnector>
        }
      >
        <Step className={classes.stepBallVerticalNormal}>
          <StepLabel className={classes.stepLabel}>
            {t('commons.start')}
          </StepLabel>
          <StepLabel className={classes.subDate} icon={false}>
            {history?.processData?.start ? moment(history?.processData?.start).format('DD/MM/YYYY HH:mm:ss') : ''}
          </StepLabel>
        </Step>
        {history?.tabs
          ?.map((step, idx) => (
            <Step
              key={`${step.id}${idx}`}
              className={
                step?.date === null
                  ? classes.stepBallVerticalEmpty
                  : classes.stepBallVerticalNormal
              }
            >
              <StepLabel className={classes.stepLabel}>
                {step.tabName}
              </StepLabel>
              <StepLabel className={classes.subDate} icon={false}>
                {step.date ? moment(step.date).format('DD/MM/YYYY HH:mm:ss') : ''}
              </StepLabel>
            </Step>
          ))
          .reverse()}
        <Step className={classes.stepBallVerticalNormal}>
          <StepLabel className={classes.stepLabel}>
            {t('commons.end')}
          </StepLabel>
          <StepLabel className={classes.subDate} icon={false}>
            {history?.processData?.finish ? moment(history?.processData?.finish).format('DD/MM/YYYY HH:mm:ss') : ''}
          </StepLabel>
        </Step>
      </Stepper>
    </Box>
  )
}

export default withTranslation()(memo(RenderVerticalStepper))
